import { useAppSelector } from "./reduxHooks";
import { selectWhiteLabelsState } from "app/data/selectors/whiteLabelsSelectors";
import { IWhiteLabelConfiguration } from "app/data/types";

export const DEFAULT_BRAND_NAME = "Allsetra";

/**
 * Resolves the customer-facing name of the tenant running this deployment.
 *
 * The fallback triggers on a missing *value*, not on a missing whitelabel: a
 * configured whitelabel that left its account name blank must still read
 * "Allsetra" rather than an empty name. On the Allsetra deployment there is no
 * whitelabel at all, and "Allsetra" is the correct output.
 */
/**
 * Ends a sentence with the brand without doubling its punctuation: legal entity
 * names usually end in a period of their own ("Loqater Benelux B.V."), and
 * appending another gives "... van Loqater Benelux B.V..".
 */
export const endSentenceWithBrand = (brand: string): string =>
  brand.endsWith(".") ? brand : `${brand}.`;

const useBrandName = (): string => {
  const { whiteLabel } = useAppSelector(selectWhiteLabelsState);

  const accountName = (whiteLabel as IWhiteLabelConfiguration | null)
    ?.whiteLabelAccountName;

  return accountName?.trim() || DEFAULT_BRAND_NAME;
};

export default useBrandName;
